// extracted by mini-css-extract-plugin
module.exports = {"icon":"ChatIcon_icon__0vCvJ"};